import styled from 'styled-components';

const SideBar = styled.div`
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
`;

export default SideBar;

